module.exports = __webpack_public_path__ + "img/168373304017982_image.jpg";